import SaveDialog from "designSystem/components/dialog/SaveDialog";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import ComplianceAnalysisBypassPopupStore, { ComplianceAnalysisBypassPopupStoreContext } from "./ComplianceAnalysisBypassPopupStore";
import { ControllerProps } from "csi/middleware/common";
import ComplianceAnalysisBypassPopupContent from "./ComplianceAnalysisBypassPopupContent";

export interface ComplianceAnalysisBypassPopupProps extends ControllerProps {
    store: ComplianceAnalysisBypassPopupStore ;
}

export const ComplianceAnalysisBypassPopup: FunctionComponent<ComplianceAnalysisBypassPopupProps> = observer((props) => {
	const {
		store,
		onClose,
	} = props;

	const {
		isSaveButtonEnabled,
		onSave,
		titleRes,
	} = store || {};

	return (
		<>
			{ store && (
				<ComplianceAnalysisBypassPopupStoreContext.Provider value={store}>
					<SaveDialog
						contentDisplayFlex
						contentSpacing={0}
						disableSave={!isSaveButtonEnabled}
						onClose={onClose}
						onSave={onSave}
						open
						scrollContent="none"
						showClose
						titleRes={titleRes}
					>
						{{
							main: (
								<ComplianceAnalysisBypassPopupContent />
							),
						}}
					</SaveDialog>
				</ComplianceAnalysisBypassPopupStoreContext.Provider>
			) }
		</>
	);
});

export default ComplianceAnalysisBypassPopup;